export const setMapForFilterQuery = (data, notIndicated) => {
  const map = data.reduce((acc, item) => {
    acc.set(item.id, { ...item, amount: 0 });
    return acc;
  }, new Map());

  if (notIndicated) {
    map.set(0, notIndicated);
  }

  return map;
};
